// src/components/Dashboard/RobotCard.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { Robot } from '../../types';

interface RobotCardProps {
  robot: Robot;
}

const RobotCard: React.FC<RobotCardProps> = ({ robot }) => {
  return (
    <div className={`robot-card ${robot.status}`}>
      <h3>
        <span className="status-dot"></span> {robot.name} (ID: {robot.id})
      </h3>
      <div className="robot-info">
        <div className="robot-info-item">
          <span className="label">Статус:</span>
          <span>{robot.status === 'online' ? '🟢 Онлайн' : '🔴 Офлайн'}</span>
        </div>
        <div className="robot-info-item">
          <span className="label">Батарея:</span>
          <span>{robot.battery}</span>
        </div>
        <div className="robot-info-item">
          <span className="label">Последний контакт:</span>
          <span>{robot.lastSeen}</span>
        </div>
      </div>
      <Link to={`/control/${robot.id}`} className="control-link">
        Управление →
      </Link>
    </div>
  );
};

export default RobotCard;